import React, { Component } from 'react';
import './OptOut.css'

import FaLoading from 'react-icons/lib/fa/circle-o-notch';

export default class OptOut extends Component {
	state = {
		myViewOptedOut: false,
		rnOptedOut: false,
		error: false,
		showPixels: false,
		pixelKey: 0
	};

	handleMyViewLoad = () => {
		this.setState((prevState) => {
			const newState = { myViewOptedOut: true };
			if (prevState.rnOptedOut) {
				newState.loading = false;
			}
			return newState;
		});
	};

	handleRnLoad = () => {
		this.setState((prevState) => {
			const newState = { rnOptedOut: true };
			if (prevState.myViewOptedOut) {
				newState.loading = false;
			}
			return newState;
		});
	};

	handleError = () => {
		this.setState({ loading: false, error: true });
	};

	handleOptOut = () => {
		this.setState((prevState) => ({
			loading: true,
			myViewOptedOut: false,
			rnOptedOut: false,
			error: false,
			showPixels: true,
			pixelKey: prevState.pixelKey + 1
		}));
	};

	render () {
		const { myViewOptedOut, rnOptedOut, loading, error, showPixels, pixelKey } = this.state;
		const optedOut = myViewOptedOut && rnOptedOut;
		const t = this.props.translatedText;
		return (
			<div className="opt-out-wrapper">
				<div className="opt-out-inner">
					<h1 className="opt-out-header">{t.title}</h1>
					{!optedOut ?
						<OptOutForm
							handleClick={this.handleOptOut}
							t={t}
							loading={loading}
							error={error}
						/>
					:
						<SuccessMessage t={t} />
					}
				</div>
				{showPixels && (
					<div>
						<img key={pixelKey + '-mv'} id="myViewOptOut" src="https://t.myview.com/o" onLoad={this.handleMyViewLoad} onError={this.handleError} />
						<img key={pixelKey + '-rn'} id="rnOptOut" src="https://t.researchnow.com/o" onLoad={this.handleRnLoad} onError={this.handleError} />
					</div>
				)}
			</div>
		)
	}
}

const OptOutForm = ({ handleClick, t, loading, error }) => (
	<div className="opt-out-form">
		<p>{t.body[0]}</p>
		<p className="opt-out-description">{t.body[1]}</p>
		<p>{t.cta}</p>
		{error && <p style={{color: 'red'}}>Something went wrong. Please try again.</p>}
		<button className="opt-out-submit-button" onClick={handleClick}>{loading ? <FaLoading /> : t.button}</button>
	</div>
);

const SuccessMessage = ({ t }) => (
	<div className="opt-out-success-message">
		<p>{t.confirmation}</p>
	</div>
);



// WEBPACK FOOTER //
// ./src/components/OptOut/OptOut.js